import request from './request_service';
import UrlService from './url_service';
import AuthenticationService from './authentication_service'
class AppService {


    static validateIdentification(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/public/"+data.identificationType+"/verification";
        options.params = data;
        options.authenticated = false;
        return request.post(options);
    }

    static updateAdvertDetailInfo(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/advert/update";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }


    static createAdvertDetailInfo(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/advert";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }
    
    static getAdvertDetailInfo(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/advert/info";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }


    static getGiveawayImageTemplates() {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/public/parameter/GIVEAWAY_IMAGE_TEMPLATE";
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static generateGiveawayImage(data) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/public/generate/image";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static updateGiveaway(data, switchGameType) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/giveaway/update";
        if(switchGameType) {
            options.url = UrlService.MULTISERVICE_BASE_API + "/general/giveaway/switch";
        }
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }
    
    
    static getGiveawaySummary() {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/giveaway/summary";
        options.authenticated = true;
        options.authenticated = true;
        return request.get(options);
    }


    static getOrdersByCategory(pageSize,pageNumber, category) {
        let options = Object();
        options.url = UrlService.ECOMMERCE_BASE_URL + "/orders/category/"+category;
        options.authenticated = true;
        options.headers = {
            'pagesize': pageSize,
            'pagenumber': pageNumber,
        }
        options.authenticated = true;
        return request.get(options);
    }

    
    
    static startAirtimeDisbursement(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/start/order/disbursement";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static submitAirtimeDisbursement(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/airtime/record";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static createAirtimeOrder(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/airtime/order";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static addOptionEndpoint(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/evoting/option";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static deleteOptionEndpoint(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/evoting/option/delete";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }
    
    static addParticipantEndpoint(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/evoting/candidate";
        options.params = data;
        options.authenticated = false;
        return request.post(options);
    }

    static deleteParticipantEndpoint(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/evoting/candidate/delete";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static notifyParticipantEndpoint(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/evoting/candidate/notify";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static voteEndpoint(data, id) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/voting/"+id;
        options.params = data;
        options.authenticated = false;
        return request.post(options);
    }

    
    

    static getEvotingDetail(pageSize,pageNumber, ref, showResult) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/evoting/detail/"+ref+"?showResult="+showResult;
        options.params = null;
        options.authenticated = false;
        options.headers = {
            'pagesize': pageSize,
            'pagenumber': pageNumber,
        }
        return request.get(options);
    }

    
    static toggleClosingStatus(ref) {
        let options = Object();
        let dummy = {};
        dummy.n = "d";
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/evoting/status/toggle/"+ ref;
        options.params = dummy;
        options.authenticated = true;
        return request.post(options);
    }
    
    static createEvote(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/evoting";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static getEvoters(pageSize,pageNumber) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/evoting";
        options.authenticated = true;
        options.headers = {
            'pagesize': pageSize,
            'pagenumber': pageNumber,
        }
        options.authenticated = true;
        return request.get(options);
    }

    
    static getOrderByRef(ref) {
        let options = Object();
        options.url = UrlService.ECOMMERCE_BASE_URL + "/order/detail/"+ref;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static getDirectGiveawayRedeemption(id) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/giveaway/redeem/direct/"+id;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static getMyGiveawaysByRef(pageSize,pageNumber, ref) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/giveaways/reference/"+ref;
        options.params = null;
        options.authenticated = true;
        options.headers = {
            'pagesize': pageSize,
            'pagenumber': pageNumber,
        }
        return request.get(options);
    }

    static getGiveawayOrders(pageSize,pageNumber) {
        let options = Object();
        options.url = UrlService.ECOMMERCE_BASE_URL + "/orders/description/GIVEAWAY";
        options.authenticated = true;
        options.headers = {
            'pagesize': pageSize,
            'pagenumber': pageNumber,
        }
        options.authenticated = true;
        return request.get(options);
    }

    static paystackPaymentConfirmation(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/giveaway/value";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static getMyGiveaways(pageSize,pageNumber) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/giveaways?page="+pageNumber+"&size="+pageSize;
        options.params = null;
        options.authenticated = true;
        options.headers = {
            'pagesize': pageSize,
            'pagenumber': pageNumber,
        }
        return request.get(options);
    }

    static getTransactions(pageSize,pageNumber) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/transactions";
        options.params = null;
        options.authenticated = true;
        options.headers = {
            'pagesize': pageSize,
            'pagenumber': pageNumber,
        }
        return request.get(options);
    }

    static getUserTransactions(pageSize,pageNumber) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/user/transactions";
        options.params = null;
        options.authenticated = true;
        options.headers = {
            'pagesize': pageSize,
            'pagenumber': pageNumber,
        }
        return request.get(options);
    }

    


    static verifyEmailAddress(data) {
        let options = Object();
        options.url = UrlService.BASE_PATH + "/api/v1/users/email/verification/"+data.token;
        options.params = null;
        options.authenticated = false;
        return request.get(options);
    }


    static logoutUAuth() {
        let options = Object();
        options.url = UrlService.UAUTH_BASE_PATH + "/exit";
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }
    static paymentConfirmation(data) {
        let options = Object();
        options.url = UrlService.ECOMMERCE_BASE_URL + "/payment/confirmation";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }
    static payWithAccount(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/pay/with/account";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }
    static registerOrder(data) {
        let options = Object();
        options.url = UrlService.ECOMMERCE_BASE_URL + "/order/registration";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static getCustomerDashboard() {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/customer/dashboard";
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static getCustomerDashboardRefresh() {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/customer/dashboard/refresh";
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }


    static getMyReferrals() {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/my/referrals";
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static updateAccountFcm(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/account/fcm";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static unsupportedBrowser(data) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/browser/unsupported";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    

    static getAccountDetail() {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/account/detail";
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }


    static updateAccountDetail(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/account/detail";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static updateAccountDetailKycVerification(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/account/detail/kyc/verification";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static buyAirtime(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/purchase/airtime";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static fundsWithdrawal(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/funds/withdrawal";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static nameEnquiry(bankCode, accountNumber) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + UrlService.ENQUIRY + bankCode + "/" + accountNumber;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static getBeneficiaryUsername(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/beneficiary/username" ;
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static initiatePeerToPeer(data) {
        let options = Object();
        options.url = UrlService.MULTISERVICE_BASE_API + "/general/peer/to/peer" ;
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static initiateFunding(data) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/initiate/transfer" ;
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static confirmPayment(ref) {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/fund/wallet/"+ref;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }


    

    static getBanks() {
        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + UrlService.BANK_LIST;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static getCoinPrice() {
        let options = Object();
        options.url = "https://api.coincap.io/v2/assets";
        options.params = null;
        options.authenticated = false;
        return request.get(options);
    }

    static getMainOrders(params) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/main/sell/requests";
        options.params = null;
        options.authenticated = false;
        options.headers = {
            'pagesize': params.pageSize,
            'pagenumber': params.pageNumber,
        }
        return request.get(options);
    }

    static searchProduct(params) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/search/products";
        options.params = params;
        options.authenticated = false;
        options.headers = {
            'pagesize': params.pageSize,
            'pagenumber': params.pageNumber,
        }
        return request.post(options);
    }

    static getChatBuyers() {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/chat/buyers";
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static getPotentialSales(id) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/potential/sales/" + id;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }


    static getOrderById(id) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/sell/request/" + id;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }


    static updateSellRequest(data) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/sell/request/" + data.id;
        options.params = data;
        options.authenticated = true;
        return request.put(options);
    }


    static getChatItemById(id) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/chat/item/" + id;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static getChatItemByRef(ref) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/chat/ref/item/" + ref;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }


    static postSellRequest(data) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/sell/request";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }

    static getPersonalRequests() {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/personal/sell/requests";
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static getStoreRequests(id) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/store/sell/requests/" + id;
        options.params = null;
        options.authenticated = false;
        return request.get(options);
    }

    static getStoreItem(slug) {
        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/sell/info/" + slug;
        options.params = null;
        options.authenticated = false;
        return request.get(options);
    }


    static login(params) {
        console.log("paran")

    }


    
    static setPassword(data) {
        let options = Object();
        options.url = UrlService.BASE_PATH + "/api/v1/users/set/password";
        options.params = data;
        options.authenticated = false;
        return request.post(options);
    }

    static passwordReset(data) {
        let options = Object();
        options.url = UrlService.BASE_PATH + "/api/v1/users/password/reset";
        options.params = data;
        options.authenticated = false;
        return request.post(options);
    }

    static signUp(data) {
        let options = Object();
        options.url = UrlService.BASE_PATH + "/api/v1/users/signup";
        options.params = data;
        options.authenticated = false;
        return request.post(options);
    }

    static uploadonly(params) {
        const formData = new FormData();
        formData.append('file', params.upload);

        let options = Object();
        options.url = UrlService.PAYMENT_API_BASE_PATH + "/generic/file/upload";
        options.formData = true;
        options.params = formData;
        options.authenticated = true;

        return request.post(options);
    }


    static uploadAirtimeSheet(params) {
        const formData = new FormData();
        formData.append('file', params.upload);

        let options = Object();
        options.url = UrlService.MAIN_PAYMENT_API_BASE_PATH + "/airtime/file/upload";
        options.formData = true;
        options.params = formData;
        options.authenticated = true;

        return request.post(options);
    }

}

export default AppService;